/*
  Подписи сведений реестра банкротств (23.10.2026, вынесено из
  `RegistryPersonResult.jsx` вместе с правкой подписей по ревизии).

  Дата в строке процедуры значит разное по виду и состоянию, и подпись обязана
  это назвать: оператор переносит даты в форму «Банкротство» сам (строка 259
  реестра компромиссов), и неверная подпись ведёт его к неверной дате.

  - Судебная: даты - судебных актов. «Акт», а не «определение»: реализацию
    имущества вводит решение суда о признании банкротом.
  - Внесудебная (через МФЦ): даты - ПУБЛИКАЦИИ сообщений о возбуждении,
    завершении, прекращении; судебного акта у неё нет.

  Ни одна из этих дат - не дата принятия заявления о банкротстве, от которой
  считается граница реестрового и текущего долга: реестр её отдельно не
  публикует, она в тексте сообщения о принятии заявления (показывается рядом).
*/

import { date } from '../api/format.js'

const STARTED = {
  judicial: 'введена судебным актом от',
  extrajudicial: 'сообщение о возбуждении опубликовано',
}

const ENDED = {
  judicial: { completed: 'акт о завершении от', terminated: 'акт о прекращении от' },
  extrajudicial: {
    completed: 'сообщение о завершении опубликовано',
    terminated: 'сообщение о прекращении опубликовано',
  },
}

/* Состояние незнакомое (служба дополнила перечень) - подпись без толкования. */
const ENDED_UNKNOWN = 'сведения об окончании от'

export function procedureLine(procedure) {
  const parts = [`${procedure.kind_title}: ${procedure.state_title}`]
  if (procedure.court) parts.push(procedure.court)
  if (procedure.case_number) parts.push(`дело ${procedure.case_number}`)
  if (procedure.introduced_on) {
    parts.push(`${STARTED[procedure.kind] ?? 'начало'} ${date(procedure.introduced_on)}`)
  }
  if (procedure.claims_deadline) {
    parts.push(`реестр требований закрывается ${date(procedure.claims_deadline)}`)
  }
  if (procedure.ended_on) {
    const label = ENDED[procedure.kind]?.[procedure.state] ?? ENDED_UNKNOWN
    parts.push(`${label} ${date(procedure.ended_on)}`)
  }
  if (procedure.discharge) parts.push(procedure.discharge)
  return parts.join('; ')
}

export function acceptanceLine(acceptance) {
  const published = acceptance.published_on
    ? ` - сообщение опубликовано ${date(acceptance.published_on)}`
    : ''
  return `Суд принял заявление о банкротстве${published}. Дата принятия - в тексте сообщения.`
}

export function otherMessagesLine(count) {
  return (
    `Иных сообщений в реестре: ${count}. Сведения о процедуре публикуют и так, а их текст ` +
    'служба не разбирает - прочитайте их в реестре сведений о банкротстве сами.'
  )
}

/* «Не установлена» - только когда сводка пришла и в ней нет ничего: ни процедуры,
   ни принятого заявления, ни иных сообщений. Сводка говорит «по судебным актам не
   установлено», а не «процедуры нет» (договор службы, 23.10.2026). */
export function nothingEstablished(card) {
  return (
    card.has_messages &&
    card.procedures.length === 0 &&
    (card.acceptances ?? []).length === 0 &&
    !card.other_messages
  )
}
